// eslint-disable-next-line @woocommerce/dependency-group
import './style.scss';
import './gutenberg';

import { pglyInitCodeEditors, openCustomScriptsModal } from './component/popup';

/**
 * SmartCare Backend JS
 *
 * Licensed under the GPLv2+ license.
 */
jQuery(document).ready(function ($) {
    'use strict';

    $.pglyBackend = {
        /**
         * Initialize hooks and functions
         */
        init() {

            this.addPopupBtntoClassicEditor();

            // Open modal.
            $(document).on('click', '#smcr-classic-scripts-btn', openCustomScriptsModal);

            // Close modal
            $(document).on(
                'click',
                '.smcr-modal-btn-close, .smcr-modal-btn-cancel, .smcr-modal-overlay',
                this.hideScriptModal
            );

            // Switch tabs
            $(document).on('click', '.smcr-tab-btn', this.onScriptTabClick);
        },

        addPopupBtntoClassicEditor() {
            const postTitle = $('.page-title-action');
            if (postTitle.length && !$('#smcr-classic-scripts-btn').length) {
                // var primaryColor = getComputedStyle(document.documentElement)
                // .getPropertyValue('--wp-admin-theme-color')
                // .trim();

                const buttonHtml = `<a type="button" class="page-title-action" style="background: #135e96; color: #fff;" id="smcr-classic-scripts-btn">
                    <span class="dashicon dashicons dashicons-admin-customizer" style="vertical-align: middle;
                    line-height: 1;
                    font-size: 16px;"></span>
                    ${wp.i18n.esc_html__('Custom CSS & JS', 'current-template-name')}
                </a>`;
        
                // Insert after the "Add New" button.
                postTitle.after(buttonHtml);
            }
        },        

        /**
         * Hide modal
         */
        hideScriptModal(event) {
            event.preventDefault();
            $('#smcr-custom-scripts-popup').hide();
        },

        /**
         * Switch tab
         */
        onScriptTabClick(event) {
            event.preventDefault();
            const tab = $(this).data('tab');

            // Activate button.
            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            // Activate tab content.
            $('.smcr-tab-content').removeClass('active');
            $('.smcr-tab-content[data-tab="' + tab + '"]').addClass('active');

            // Activate enable Checkbox.
            $('.smcr-tab-enable-checkbox').removeClass('active');
            $('.smcr-tab-enable-checkbox[data-tab="' + tab + '"]').addClass('active');
        },
    };

    // Initialize
    $.pglyBackend.init();
});
